module.exports = __webpack_public_path__ + "static/media/hz_banner.3a29a660.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_banner.jpg
// module id = 1586
// module chunks = 10